$(function() {
	function resizeBlock() {
		$('.js-resize').each(function(){
			var offset = parseInt($(this).attr('data-height')) || 0;
			var id = $(this).attr('data-resize');
			var height = $(id).outerHeight() + offset;
			if ($(window).width() > 756) {
				$(this).css({height: height});
			} else {
				$(this).css({height: "auto"});
			}
		});
	};

	// function rightExceed() {
	// 	var margin = ($(".container").outerWidth(true) - $(".container").outerWidth())/2 + 15;
	// 	$('.js-exceed-right').each(function(){
	// 		var width = $(this).parent().width()
	// 	    if ($(window).width()>991) {
	// 	      $(this).css({width: width + margin})
	// 	    } else {
	// 	      $(this).css({width: "100%" })
	// 	    }
	// 	});
	// 	$('.js-exceed-left').each(function(){
	// 	    var width = $(this).parent().width()
	// 	    if ($(window).width()>991) {
	// 	    $(this).css({"margin-left": -margin, width: width + margin })
	// 	    } else {
	// 	      $(this).css({"margin-left": 0, width: "100%" })
	// 	    }
	// 	});
	// };

	$(window).resize(function(){
		resizeBlock()
		// rightExceed()
	})

	resizeBlock()
	// rightExceed()
});
